import React, { useState, useEffect, createContext, useContext } from 'react';
import { BREAKPOINTS } from '../constants';

const QUERIES = {
    onDesktop: `(min-width: ${BREAKPOINTS.onDesktop}px)`,
    x_2200: `(min-width: ${BREAKPOINTS.x_2200}px)`,
    ultra: `(min-width: ${BREAKPOINTS.ultra}px)`,
    xxxxl: `(min-width: ${BREAKPOINTS.xxxxl}px)`,
    x_1760: `(min-width: ${BREAKPOINTS.x_1760}px)`,
    x_1680: `(min-width: ${BREAKPOINTS.x_1680}px)`,
    xxxl: `(min-width: ${BREAKPOINTS.xxxl}px)`,
    xxl: `(min-width: ${BREAKPOINTS.xxl}px)`,
    xl: `(min-width: ${BREAKPOINTS.xl}px)`,
    lg: `(min-width: ${BREAKPOINTS.lg}px)`,
    md: `(min-width: ${BREAKPOINTS.md}px)`,
    sm: `(min-width: ${BREAKPOINTS.sm}px)`,
    xs: `(min-width: ${BREAKPOINTS.xs}px)`
};

const defaultValue: any = {};

const MatchMediaContext = createContext(defaultValue);

const MatchMediaProvider = ({ children }) => {
    const [queryMatch, setQueryMatch] = useState({});

    useEffect(() => {
        const mediaQueryLists = {};
        const keys = Object.keys(QUERIES);
        let isAttached = false;

        const handleQueryListener = () => {
            const updatedMatches = keys.reduce((acc, media) => {
                acc[media] = !!(mediaQueryLists[media] && mediaQueryLists[media].matches);
                return acc;
            }, {});
            setQueryMatch(updatedMatches);
        };

        if (window && window.matchMedia) {
            const matches = {};
            keys.forEach(media => {
                mediaQueryLists[media] = window.matchMedia(QUERIES[media]);
                matches[media] = mediaQueryLists[media].matches;
            });
            setQueryMatch(matches);
            isAttached = true;
            keys.forEach(media => {
                mediaQueryLists[media].addListener(handleQueryListener);
            });
        }

        return () => {
            if (isAttached) {
                keys.forEach(media => {
                    mediaQueryLists[media].removeListener(handleQueryListener);
                });
            }
        };
    }, []);

    return <MatchMediaContext.Provider value={queryMatch}>{children}</MatchMediaContext.Provider>;
};

function useMatchMedia() {
    const context = useContext(MatchMediaContext);
    if (context === defaultValue) {
        console.error('useMatchMedia musi byt pouzity v MatchMediaProvider');
    }
    return context;
}
export { useMatchMedia, MatchMediaProvider };
